module.exports = __webpack_public_path__ + "media/images/spinner/Spinner-1s-200px-7e92140c78eaff57c640ae3c1b274d53.gif";